<template>
    <div>
        <div class="faq-area default-padding bg-gray" style="padding-top: 80px; padding-left: 30%;">
            <div class="container">
                <div class="faq-items">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="faq-content pt-5 pb-5">
                                <div class="services-area bg-gray left-border bottom-less">
                                    <!-- Shape Fixed Rotation -->
                                    <div class="shape-fixed animation-rotation"><img src="assets/img/round-shappe.png" alt="Thumb" /></div>
                                    <div class="container" style="padding: 0px; border-radius: 16px;">
                                        <div class="services-items">
                                            <div class="form-box" style="width: 470px;">
                                                <div class="row">
                                                    <div v-if="!consultaInfo" class="col-md-12">
                                                        <h4>Consultar Información usuario Vapp</h4>

                                                        <div class="form-group">
                                                            <label for="inputTextuserName">
                                                                Nombre de Usuario Vapp
                                                                <span class="textUserName">(Ejemplo: usuario@vapp.cl)</span>
                                                            </label>
                                                            <input type="text" id="inputTextuserName" v-model="usuario"
                                                                placeholder="Su nombre de usuario aquí" required
                                                                class="form-control mb-2" />

                                                            <label for="inputMail">
                                                                Correo personal asociado a Vapp
                                                                <span class="textUserName">(Ejemplo: miCorreo@mail.com)</span>
                                                            </label>
                                                            <input type="email" id="inputMail" v-model="correo"
                                                                placeholder="Su correo personal aquí" required
                                                                class="form-control" />
                                                        </div>
                                                         <!--<Tooltip 
                                                            content="Tooltip personalizado"
                                                            position="bottom"
                                                            theme="dark"
                                                            trigger="click"
                                                            animation="scale"
                                                            :delay="300"
                                                        >-->
                                                            <div class="button">
                                                                <a href="#"  class="btn-standard  btn-restaurar" style="border: none;" @click.prevent="inicioSolicitud" :disabled="iniciandoSolicitud">
                                                                    <i class="fas fa-angle-right" v-show="!iniciandoSolicitud"></i>
                                                                    <div class="spinner-border"  v-show="iniciandoSolicitud" style="height: 2rem; width: 2rem;" role="status"></div>
                                                                    <span class="textBtn" v-if="iniciandoSolicitud">Consultando </span>
                                                                    <span class="textBtn" v-else>Consultar información</span>
                                                                </a>
                                                            </div>
                                                        <!--</Tooltip>-->
                                                    </div>
                                                    <div v-else class="col-md-12">
                                                        <h3>Información de mi usuario Vapp</h3>
                                                        <span v-if="!usuarioEncontrado.estadoUsuario">
                                                            <div style="margin-bottom: 8px; color: rgb(130, 17, 71) !important; font-size: 12px;" v-if="usuarioEncontrado.errorContrasenia" >
                                                                <span>El usuario ha sido bloqueado por multiples intentos de ingreso, si ha sido usted puede desbloquearlo aquí 
                                                                    <button @click="desbloquearUsuario" type="button" data-toggle="tooltip" data-placement="right" title="Desbloquear Usuario" class="btn" style="color: rgb(41, 35, 92);">
                                                                        <div role="status" class="spinner-border" style="display: none;">
                                                                            <span class="sr-only">Consultando...</span>
                                                                        </div>
                                                                        <i class="fas fa-lock-open"></i>
                                                                    </button>
                                                                    en caso de que no fué usted, el usuario se desbloqueará {{ usuarioEncontrado.tiempoDesbloqueo }}
                                                                </span>
                                                            </div>
                                                            <div style="margin-bottom: 8px; color: rgb(130, 17, 71) !important; font-size: 12px;" v-else>
                                                                {{ usuarioEncontrado.motivo }}
                                                            </div>
                                                        </span>
                                                        

                                                        
                                                        <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Estado Usuario
                                                            </div>
                                                            <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>
                                                                        <i class="fas fa-check-circle" style="font-size: 18px; color: green !important;" v-if="usuarioEncontrado.estadoUsuario"></i>
                                                                        <i class="fas fa-minus-circle" style="font-size: 18px; color: red !important;" v-else></i>
                                                                    </span>
                                                            </div>
                                                        </div>

                                                        <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Nombre de Usuario
                                                            </div>
                                                            <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.userName }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Nombre
                                                            </div>
                                                            <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.nombre }} {{ usuarioEncontrado.apellido }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Correo
                                                            </div>
                                                            <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.correo }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Teléfono
                                                            </div>
                                                            <div class="col-sm-6">
                                                                
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.telefono }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Fecha Creación
                                                            </div>
                                                            <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.fCreado }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                            <div class="col-sm-6 text-right">
                                                                Fecha Expiración
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                <span v-else>{{ usuarioEncontrado.fExpiracion }}</span>
                                                            </div>
                                                            </div>

                                                            <div class="row" style="margin-bottom: 8px;">
                                                                <div class="col-sm-6 text-right">
                                                                    Último Ingreso
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="spinner-border" v-if="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                    <span v-else>{{ usuarioEncontrado.ultimoIngreso }}</span>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-6">
                                                                     <div class="button">
                                                                        <a href="#"  class="btn-standard  btn-restaurar" style="margin-top: 0px; padding: 0px 10px;" @click.prevent="inicioSolicitud">
                                                                            <div class="spinner-border"  v-show="iniciandoSolicitud" style="height: 1rem; width: 1rem;" role="status"></div>
                                                                            <span class="textBtn" v-if="iniciandoSolicitud">Consultando </span>
                                                                            <span class="textBtn" v-else>Actualizar información</span>
                                                                        </a>
                                                                    </div>

                                                                </div>
                                                                <div class="col-sm-6">
                                                                   
                                                                    <div class="button">
                                                                        <a href="#"  class="btn-standard btn-restaurar" style="margin-top: 0px; padding: 0px 10px;" @click.prevent="limpiarSolicitud">
                                                                            <span class="textBtn">Consultar Otro Usuario</span>
                                                                        </a>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                    </div>
                                                        
                                                        
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


</template>

<script>

    import axios from "axios"
    import cons from '@/utils/const'
    import { differenceInSeconds, formatDuration, intervalToDuration } from 'date-fns';
    import { es } from 'date-fns/locale';

export default {
    name: "InfoUsuarioVapp",
    data() {
        return {
            

            //solicitud
            usuario: "",
            correo: "",
            iniciandoSolicitud: false,
            consultaInfo: false,
            //fin solicitud

            usuarioEncontrado: null,
        };
    },
    beforeDestroy(){
    },
    mounted() {
       
    },

    methods: {
        inicioSolicitud: function () {
            this.iniciandoSolicitud = true;
            var url = `${cons.protocol}://${cons.ipServer}/get_info_usuario_vapp`
            
            this.mostrarNotificaciones(4, "Consultando Información...");

            axios({
                method: "POST",
                url: url,
                data: {
                    "info": {
                        "userName": this.usuario,
                        "mailUser": this.correo
                    }
                },
            })
            .then((result) => {
                this.mostrarNotificaciones(1, result.data.mensajeGeneral, 50)
                this.usuarioEncontrado = result.data.usuarioInfo;
                this.consultaInfo = true;
            },
            (error) => {
                this.mostrarNotificaciones(2, error.response.data.mensajeGeneral, 50)
            })
            .finally(() => {
                this.iniciandoSolicitud = false;
            });
        },
        desbloquearUsuario: function () {
            var url = `${cons.protocol}://${cons.ipServer}/desbloquear_usuario_vapp`
            axios({
                method: "POST",
                url: url,
                data: {
                    "info": {
                        "userName": this.usuario
                    }
                },
            })
            .then((result) => {
                this.mostrarNotificaciones(1, result.data.mensaje, 50)
                this.inicioSolicitud();

            },
            (error) => {
                this.mostrarNotificaciones(2, error.response.data.mensaje, 50)
                
            })
        },
        limpiarSolicitud: function () {
            this.iniciandoSolicitud = false;
            this.consultaInfo = false;
            this.usuarioEncontrado = null;
        }


    }
};
</script>

<style scoped>

h3 {
    text-align: center;
    margin-bottom: 20px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 14px;
}

.status-ok {
    color: #00ff99;
    font-size: 18px;
}

/* ===== FORM BOX CON TRANSICIÓN DEGRADADO ===== */
.form-box {
  position: relative;
  background-color: white;
  padding: 30px;
  border-radius: 16px;
  color: #333;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: color 0.3s ease;
}

/* Gradiente que sube al hacer hover */
.form-box::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0%;
  background: linear-gradient(to top, #3e1f61, #3a8dde);
  border-radius: inherit;
  z-index: 0;
  transition: height 0.5s ease;
}

.form-box:hover::before {
  height: 100%;
}

/* Asegura que el contenido esté encima del gradiente */
.form-box > * {
  position: relative;
  z-index: 1;
}
.form-box:hover,
.form-box:hover * {
  color: white !important;
}
.form-box:hover .estado-icono {
  color: inherit !important;
}
.form-box:hover i {
  color: inherit !important;
}

/* ===== ESTILOS DE LABEL Y TEXTO DE EJEMPLO ===== */

/* Texto del label (negro a blanco) */
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 3px;
  color: #000;
  transition: color 0.3s ease;
}

/* Texto de ejemplo (rojo a negro) */
.textUserName {
  font-size: 12px;
  color: #d12b2b;
  margin-left: 4px;
  transition: color 0.3s ease;
}

/* Colores al hacer hover en .form-box */
.form-box:hover .form-group label {
  color: #000;
}

.form-box:hover .textUserName {
  color: white;
}


/* Inputs */
/* ===== INPUTS ===== */
.form-control {
  background-color: #fff;
  color: #333;
  border: none;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  transition: box-shadow 0.3s;
}

.form-control:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(100, 149, 237, 0.4);
}


/* Estado base con gradiente */
.btn-restaurar a.btn-restaurar {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  padding: 12px 24px !important;
  border-radius: 50px !important;
  font-weight: bold !important;
  font-size: 16px !important;
  color: black !important;
  background: linear-gradient(to right, #6e184c, #380d48) !important; /* gradiente base */
  text-decoration: none !important;
  transition: background 0.3s ease, transform 0.2s ease !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3) !important;
}

/* Hover: color sólido #5c1c46 */
.btn-restaurar:hover {
  background: #5c1c46 !important;
  transform: translateY(-2px) !important;
  color: white !important;
  border: #000;
}
.form-box:hover a.btn-restaurar{
    border: 1px solid #e7e7e7 !important;
}

.textBtn:hover{
  color: white !important;
}
.form-box:hover .textBtn{
    color: white !important;
}


/* Spinner opcional */
.spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
  color: #000;
}
.form-box:hover .spinner-border {
  color: white;
}

.password-rules {
  padding-left: 0;
  list-style: none;
  font-size: 11px;
}

.password-rules li {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.password-rules li::before {
  display: inline-block;
  margin-right: 3px;
}

.form-control-password {
  background-color: #fff;
  color: #333;
  border: none;
  padding: 14px 16px;
  border-radius: 12px;
  font-size: 15px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  transition: box-shadow 0.3s;
}

.form-control-password:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(100, 149, 237, 0.4);
}

.input-password {
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #ccc;
  font-size: 16px;
  transition: border-color 0.3s;
  background-color: #fff;
  color: #333;
}

.input-password:focus {
  border-color: #3a8dde;
  outline: none;
}

/* Input con error */
.form-control-password.error {
  border-color: #e63946 !important;
}

/* Icono ojo a la derecha */
.input-group-password {
  position: relative;
  display: flex;
  align-items: center;
}

.input-group-password .toggle-password {
  position: absolute;
  right: 16px;
  cursor: pointer;
  color: #666;
  font-size: 18px;
  z-index: 2;
}


</style>
